import React, { useContext } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';

import history from '../history';
import Users from './users';
import Settings from './settings';
import NotFound from './notfound';
import UserRoles from '../components/screens/settings/RolesPermissions';
import ProfileSettings from './Profile';
import Logs from './logs';
import Lookup from './lookup';
import ZoneLookup from '../components/screens/settings/Lookup/ZoneLookup/Zone';
import StateLookup from '../components/screens/settings/Lookup/StateLookup/State';
import LGALookup from '../components/screens/settings/Lookup/LGALookup/lga';
import SectorLookup from '../components/screens/settings/Lookup/SectorLookup/index';
import Configurations from './configurations';
import CategoryAccess from '../access/CategoryAcess';
import { AppContext } from '../store/AppContext';
import VerifyPayment from './../components/screens/VerifyPayments/VerifyPayment';
import Test from './test';
import Analytics from './analytics';
import Reporting from './reporting';
import Templates from './templates';
import Facility from './Facility';
import FacilityCreate from './FacilityCreate';
import FacilityUpdate from './FacilityUpdate';
import FacilityInvoice from './FacilityInvoice';
import FacilityQuarters from './FacilityQuarters';
import FacilityResults from './FacilityResults';
import Payment from './Payment';
import Result from './Result';
import ResultView from './ResultView';
import Invoice from './Invoice';
import FacilityView from './FacilityView';
import UserInvite from './UserInvite';
import FacilityJoin from './FacilityJoin';
import Consultants from './Consultants';
import ConsultantsView from './ConsultantsView';
import Dashboard from './Dashboard';
import QaqcPlanner from './QaqcPlanner';
import MapLive from '../components/screens/dashboard/MapLive';
import AskAi from './AskAi';

export default (props) => {
  const { state } = useContext(AppContext);
  const { firstname, lastname, status, userCategory } = state?.auth?.result?.data;

  return (
    <HashRouter history={history}>
      <Switch>
        <CategoryAccess userCategory={userCategory} exact path="/" component={Dashboard} />

        <CategoryAccess exact path="/test" component={Test} />

        <CategoryAccess exact path="/checkout" component={VerifyPayment} />

        <CategoryAccess
          userCategory={userCategory}
          path="/facilities"
          exact={true}
          component={Facility}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/facilities/create"
          component={FacilityCreate}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/facilities/join"
          component={FacilityJoin}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/facilities/:facilityId/view"
          component={FacilityView}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/facilities/:facilityId/edit"
          component={FacilityUpdate}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/facilities/invoice/:facilityId"
          component={FacilityInvoice}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/facilities/:facilityId/quarters"
          component={FacilityQuarters}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/facilities/:facilityId/quarters/result/:reportId/:quarter/:year"
          component={FacilityResults}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/invoices"
          component={Invoice}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/payments"
          component={Payment}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={true}
          path="/results"
          component={Result}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact={false}
          path="/results/view/:facilityId/:reportId/:quarter/:year"
          component={ResultView}
        />

        <CategoryAccess userCategory={userCategory} exact path="/reporting" component={Reporting} />

          <CategoryAccess userCategory={userCategory} exact path="/ask-ai" component={AskAi} />
        <CategoryAccess userCategory={userCategory} exact path="/logs" component={Logs} />

        <CategoryAccess userCategory={userCategory} exact path="/analytics" component={Analytics} />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/schedules"
          component={QaqcPlanner}
        />

        <CategoryAccess userCategory={userCategory} exact path="/settings" component={Settings} />

        <CategoryAccess userCategory={userCategory} exact path="/users" component={Users} />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/consultants"
          component={Consultants}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/consultants/:userid/view"
          component={ConsultantsView}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/users/invite"
          component={UserInvite}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/settings/roles"
          component={UserRoles}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/settings/profile"
          component={ProfileSettings}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/settings/lookups"
          component={Lookup}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/lookup/settings/zone"
          component={ZoneLookup}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/lookup/settings/state"
          component={StateLookup}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/lookup/settings/lga"
          component={LGALookup}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/lookup/settings/sector"
          component={SectorLookup}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/settings/configurations"
          component={Configurations}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/settings/templates"
          component={Templates}
        />

        <CategoryAccess
          userCategory={userCategory}
          exact
          path="/map/live"
          component={MapLive}
        />

        <CategoryAccess userCategory={userCategory} path="/" component={NotFound} />
      </Switch>
    </HashRouter>
  );
};
